import React from 'react';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

export default class CreateCancelButtons extends React.Component {
    render() {
        return (
            this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
            <div className="application-create-btns text-right">
                <button className="btn btn-accent" onClick={this.props.cancel}>Cancel</button>
                <button className="btn btn-primary"
                        disabled={this.props.disabled}
                        onClick={this.props.save}>Save
                </button>
                <FadeOutErrorMessage show={this.props.show} message={this.props.message}/>
                {this.props.disabled && <span className="info-label">{this.props.disabledMessage}</span>}
            </div>
        )
    }
}

//disabled, cancel, save, loading


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/CreateCancelButtons.jsx